
import React from 'react'
import { TextField, Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow } from '@material-ui/core';
import { useState } from 'react';
import { globalPostService, globalPutService } from '../../../globalServices';
import { checkApiStatus } from '../../../utils_v2';
import { useSnackbar } from 'notistack';


export default function AddEditQuestion({ toggleModalFn, section, params, addEditQuestion, getDocumentCheckList }) {

    const [questionData, setData] = useState(addEditQuestion?.type == 'edit' ? addEditQuestion?.data : {})
    const [isLoading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const setAddEditQuestion = async () => {
         let validationInput = {}
        validationInput={
            ...validationInput,
            question:questionData?.question?.trim() ?'':'Please enter Question'
        }
        if(Object.keys(validationInput).every(k=> validationInput[k]==='')){
        setLoading(true)
        if (!questionData?.id) {
            const response = await globalPostService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/sections/${section?.id}/questions/?asset_type=${params?.type}`,[questionData])
            setLoading(false)
            if (checkApiStatus(response)) {
                toggleModalFn()
                getDocumentCheckList()
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            } 
        } else {
            const response = await globalPutService(`technical/v2/workorder/${params?.workOrderSlug}/workbook/sections/${section?.id}/questions/${questionData?.id}/?asset_type=${params?.type}`, questionData)
            setLoading(false)
            if (checkApiStatus(response)) {
                toggleModalFn()
                getDocumentCheckList()
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            } 
        }
        } else{
            setError(validationInput)
        }
    }
    const onFieldChange = (e, key, value) => {
        setData({ ...questionData, [key]: value })
    }

    return (
        <div>
            <Dialog
                open={true}
                maxWidth='md'
            >
                <DialogTitle id="scroll-dialog-title">
                    {addEditQuestion?.type == 'edit' ?'Edit':'Add'} Question
                </DialogTitle>
                <DialogContent dividers={true} style={{width:"750px"}}>
                    <Grid container spacing={2}>
                        <Grid item sm='12' style={{ marginTop: '16px' }}>
                            <TextField
                                label='Question'
                                id={`question`}
                                fullWidth
                                margin="none"
                                multiline={questionData?.question?.length > 150?true:false}
                                rows={(questionData?.question?.length/150+1)}
                                value={questionData?.question}
                                onChange={(e) => onFieldChange(e, 'question', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                required
                                error={error?.question ? true :false}
                                helperText={error?.question}
                                onFocus={()=>setError({...error,question:''})}
                            />
                        </Grid>
                        <Grid item sm='12'>
                            <TextField
                                label='Answer'
                                id={`answer`}
                                fullWidth
                                margin="none"
                                multiline={questionData?.answer?.length > 150?true:false}
                                rows={(questionData?.answer?.length/150+1)}
                                value={questionData?.answer}
                                onChange={(e) => onFieldChange(e, 'answer', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item sm='12'>
                            <TextField
                                label='Note'
                                id={`notes`}
                                fullWidth
                                margin="none"
                                value={questionData?.notes}
                                onChange={(e) => onFieldChange(e, 'notes', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={() => toggleModalFn()} variant='outlined' color='primary' size='small' >Cancel</Button>
                    <Button disabled={isLoading} onClick={() => setAddEditQuestion()} variant={isLoading ? 'outlined' : 'contained'} color='primary' size='small'>{isLoading ? <CircularProgress size={20} /> : 'Save'}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
